import { ColorPicker, Input } from 'antd';
import React, { FC, useEffect, useState } from 'react';

import styles from '../propertiesWindow.module.scss';

type CCPProps = {
	// form: FormInstance<any>;
	name: string[];
	initialColor: string;
	onChangeColorPicker: (inputName: string[], value: string) => void;
};

export const CustomColorPicker: FC<CCPProps> = ({ /* form,  */ name, initialColor, onChangeColorPicker }) => {
	const [color, setColor] = useState(initialColor);

	useEffect(() => {
		onChangeColorPicker(name, initialColor);
	}, []);

	const onChangeColor = (_, hex: string) => {
		setColor(hex);
		// form.setFieldValue(name, hex);
		onChangeColorPicker(name, hex);
	};

	return (
		<ColorPicker defaultValue={color} disabledAlpha onChange={onChangeColor} showText>
			<div className={styles.colorPickerSquare}>
				<div
					style={{
						backgroundColor: color,
					}}
				/>
			</div>
			<Input /* name={name} */ readOnly value={color} />
		</ColorPicker>
	);
};
